(() => {
  const header = document.querySelector('[data-dar-header]');

  const updateHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-dar-close-details]');
    if (closeButton) {
      const disclosure = closeButton.closest('details');
      if (disclosure) disclosure.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.dar-disclosure[open]').forEach((item) => {
      item.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-dar-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });
})();
